import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { ProjectReference } from '@indutrust/factory-model';
import {
  legacyToProjectReference,
  projectReferenceToLegacy,
} from '@indutrust/factory-util';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for the factory-scoped project-reference sub-resource at
 * `/factories/{factoryId}/project_references`.
 *
 * Writes use the Rails `{ project_reference: … }` envelope.
 *
 * Call the inherited CRUD methods with
 * `urlSegments: { factoryId: <id> }` to bind the URL to a specific factory.
 */
@Service()
export class FactoryProjectReferenceApiClient extends BaseApiClient<ProjectReference> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<ProjectReference> = {};

  protected override fromWire(wire: unknown): ProjectReference {
    return legacyToProjectReference(wire);
  }

  protected override toWire(entity: Partial<ProjectReference>): unknown {
    return projectReferenceToLegacy(entity);
  }

  get url(): string {
    return `${this.envService.getApiUrl()}/factories/{factoryId}/project_references`;
  }
}
